var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94781 13.2139C5.22914 13.2139 5.45781 13.4425 5.45781 13.7239C5.45781 14.0052 5.22914 14.2332 4.94781 14.2332C4.66648 14.2332 4.43848 14.0052 4.43848 13.7239C4.43848 13.4425 4.66648 13.2139 4.94781 13.2139Z",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4495 13.2139C12.7308 13.2139 12.9595 13.4425 12.9595 13.7239C12.9595 14.0052 12.7308 14.2332 12.4495 14.2332C12.1681 14.2332 11.9395 14.0052 11.9395 13.7239C11.9395 13.4425 12.1681 13.2139 12.4495 13.2139Z",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83301 2.16699L3.21967 2.40699L3.86167 10.0557C3.91367 10.679 4.43434 11.1577 5.05967 11.1577H12.3343C12.9317 11.1577 13.4383 10.719 13.5243 10.127L14.157 5.75499C14.235 5.21566 13.817 4.73299 13.2723 4.73299H3.44234",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.41699 7.19661H11.2657",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.eb7cd9a6e4e32eb98263f9090afa5921.svg";
export { ForwardRef as ReactComponent };